import MainButton from '@/components/ui/custom/buttons/MainButton';
import Tag from '@/components/ui/custom/dataDisplay/Tag';
import { HistoricPanel } from '@/components/historic/HistoricPanel';
import User from '@/models/User';
import { fadeIn } from '@/utils/animations/commom';
import { ArrowTopRightOnSquareIcon, FolderOpenIcon } from '@heroicons/react/24/outline';
import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';

export default function StudentHistoric({ student }: { student: User }) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'studentHistoric',
  });

  return (
    <motion.div className="flex flex-col w-full gap-2 px-8 py-5" {...fadeIn}>
      <div className="flex gap-10 items-center">
        <Tag text={t('title')} icon={<FolderOpenIcon className="w-6 h-6" />} />
        <MainButton
          color="custom"
          className="text-primary items-center font-500 flex flex-row-reverse gap-1.5"
          text={t('fullScreen')}
          href={`/admin/student-history/${student.id}`}
          icon={<ArrowTopRightOnSquareIcon className="w-4 h-4" />}
        />
      </div>
      <HistoricPanel key={student.id} studentId={student.id} />
    </motion.div>
  );
}
